import mixpanel from "mixpanel-browser";
import useAuthStore from "@/store/use-auth-store";

// Kullanıcının monetization pop-up'ını hangi süreçte gördüğü.
export type MonetizationSource =
  | "generation"
  | "onboarding"
  | "chat"
  | "other";

// 402 dönen isteğin URL'inden süreci çıkar. Sıra önemli: creative-generation ve
// prompt uçları /ai/chat altında yaşıyor, bu yüzden chat kuralından önce gelmeli.
const SOURCE_BY_REQUEST_URL: Array<[RegExp, MonetizationSource]> = [
  [/\/onboarding(\/|$|\?)/, "onboarding"],
  [/\/creative-generation/, "generation"],
  [/\/prompt\/(enhance|translate)/, "generation"],
  [/\/ai\/chat/, "chat"],
];

// URL eşleşmezse (ör. jenerik bir uç 402 döndüyse) kullanıcının bulunduğu rota.
const SOURCE_BY_PATHNAME: Array<[RegExp, MonetizationSource]> = [
  [/^\/onboarding/, "onboarding"],
  [/^\/(wizard|wardrobe|my-wardrobe|studio)/, "generation"],
  [/^\/(chat|new-chat)/, "chat"],
];

export const resolveMonetizationSource = (
  requestUrl?: string,
): MonetizationSource => {
  if (requestUrl) {
    for (const [pattern, source] of SOURCE_BY_REQUEST_URL) {
      if (pattern.test(requestUrl)) return source;
    }
  }

  if (typeof window !== "undefined") {
    const { pathname } = window.location;
    for (const [pattern, source] of SOURCE_BY_PATHNAME) {
      if (pattern.test(pathname)) return source;
    }
  }

  return "other";
};

const track = (event: string, source: MonetizationSource) => {
  try {
    mixpanel.track(event, {
      user_id: useAuthStore.getState().user?._id ?? null,
      date: new Date().toISOString(),
      source,
    });
  } catch (e) {
    console.warn("mx error", e);
  }
};

export const trackMonetizationPopupViewed = (source: MonetizationSource) =>
  track("monetization_popup_viewed", source);

export const trackMonetizationPopupUpgradeClicked = (
  source: MonetizationSource,
) => track("monetization_popup_upgrade_clicked", source);

export const trackMonetizationPopupClosed = (source: MonetizationSource) =>
  track("monetization_popup_closed", source);
